import React from "react";
import ReactApexChart from "react-apexcharts";
import { theme } from "antd";
import { useTranslation } from "react-i18next";

// Apex sizes itself to its container (width 100% by default), so no resize listener is needed.
const StatusChart = () => {
  const { t } = useTranslation("dashboard");
  const { token } = theme.useToken();

  const series = [
    {
      name: t("Clients"),
      data: [
        { x: "2015", y: 100 },
        { x: "2016", y: 20 },
        { x: "2017", y: 90 },
        { x: "2018", y: 50 },
        { x: "2019", y: 120 }
      ]
    },
    {
      name: t("Buyers"),
      data: [
        { x: "2015", y: 30 },
        { x: "2016", y: 60 },
        { x: "2017", y: 120 },
        { x: "2018", y: 80 },
        { x: "2019", y: 150 }
      ]
    }
  ];

  const chartOptions = {
    chart: {
      type: "line",
      stacked: false,
      toolbar: { show: false },
      fontFamily: token.fontFamily
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      categories: ["2015", "2016", "2017", "2018", "2019"]
    },
    colors: [token.colorPrimary, token.colorWarning],
    stroke: {
      width: 2,
      curve: "smooth"
    },
    markers: {
      size: 3
    },
    legend: {
      position: "bottom"
    },
    grid: {
      show: true,
      borderColor: token.colorBorderSecondary,
      strokeDashArray: 2
    },
    tooltip: {
      theme: "dark"
    }
  };

  return <ReactApexChart options={chartOptions} series={series} type="line" height={280} />;
};

export default StatusChart;
